module.exports = __webpack_public_path__ + "/login_ui/img/mw-e92243c600e284e5d54982183b052cd3.svg";